import { BaseType, Selection, select } from 'd3'

/**
 * This function run d3.select to get element in DOM, but run in interval and transform the function in promise.
 *
 * @param selector The selector of element, e.g.: '#myElement'
 * @param tentatives Number of loops in interval. By default is 20.
 * @param interval Delay of tentatives. By default is 100.
 * @returns D3.Selection of element.
 */
export async function d3PromiseSelect<GElement extends BaseType, OldDatum>(
    selector: string,
    tentatives = 20,
    interval = 100
): Promise<Selection<GElement, OldDatum, HTMLElement, unknown>> {
    return new Promise((resolve, reject) => {
        let currentTentative = 0

        const timer = setInterval(() => {
            const obj = select<GElement, OldDatum>(selector)

            if (!obj) {
                currentTentative += 1
            } else {
                resolve(obj)

                clearInterval(timer)

                return
            }

            if (currentTentative >= tentatives) {
                clearInterval(timer)
                reject(new Error('Object not found.'))
            }
        }, interval)
    })
}
